<!-- <div @list class="list-container"> -->
<div @items *ngFor="let toast of toasts" class="toast {{ toast.messageType }}" (click)="onCloseToastClicked(toast)">
  <span class="toast-message" [innerHTML]="toast.message"></span>
  <div class="toast-timer" [style.animation-duration]="toast.timeoutInMs + 'ms'"></div>
  <button class="toast-close" (click)="onCloseToastClicked(toast)">x</button>
</div>
<!-- </div> -->
